export default __webpack_public_path__ + "static/media/image_5.07413fe0.jpg";